module.exports = __webpack_public_path__ + "images/spoiled-8f6680ec7bae60521d9f59c9d2aea124.png";